import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faEye, faCheck } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminDataTable.css';
import { generateSlug } from '../../../core/utils/stringUtils';

const CategoriesTable = ({ categories, onEdit, onDelete, onCategorySelect, selectAll, onSelectAll }) => {
  const handleViewClick = (categoryId, categoryName) => {
    const categorySlug = generateSlug(categoryName);
    const categoryUrl = `/boats/category/${categoryId}/${encodeURIComponent(categorySlug)}`;
    window.open(categoryUrl, '_blank');
  };

  const handleDeleteClick = (category) => {
    if (category.is_default === true) {
      alert("The 'Uncategorized' category cannot be deleted.");
    } else {
      onDelete(category);
    }
  };

  return (
    <div className="admin-data-table__container">
      <table className="admin-data-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={selectAll}
                onChange={(e) => onSelectAll(e.target.checked)}
              />
            </th>
            <th>ID</th>
            <th>Name</th>
            <th>Boat Count</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category) => (
            <tr key={category.id}>
              {category.is_default ? (
                <>
                  <td></td>
                  <td>#{category.id}</td>
                  <td>{category.name}</td>
                  <td>{category.boats_count || 0}</td>
                  <td>
                    <div className="action-buttons">
                      <button className="button secondary" onClick={() => handleViewClick(category.id, category.name)}>
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </div>
                  </td>
                </>
              ) : (
                <>
                  <td>
                    <input
                      type="checkbox"
                      checked={category.isSelected || false}
                      onChange={(e) => onCategorySelect(category.id, e.target.checked)}
                    />
                  </td>
                  <td>#{category.id}</td>
                  <td>{category.name}</td>
                  <td>{category.boats_count || 0}</td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="button secondary"
                        onClick={() => handleDeleteClick(category)}
                      >
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </button>
                      <button className="button secondary" onClick={() => onEdit(category)}>
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button className="button secondary" onClick={() => handleViewClick(category.id, category.name)}>
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </div>
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CategoriesTable;